<template>
  <div class="row">
    <div class="col-12 card-primary">
      <p class="text-xxl text-bold">Pengumuman</p>
      <!-- {{dataPengumuman}} -->
      <div v-if="dataPengumuman.length > 0">
        <carousel
          :items="4"
          :nav="false"
          :dots="false"
          :autoplay="true"
          :autoplayTimeout="30000"
        >
          <div
            class="row mt-20"
            v-for="(pengumuman, index) in dataPengumuman"
            :key="`pengumuman-${index}`"
          >
            <div class="col-12">
              <div class="card-secondary">
                <div class="row">
                  <div class="col-12">
                    <p class="text-xl text-bold">
                      {{
                        moment(pengumuman.tanggal_kegiatan)
                          .locale("id")
                          .format("dddd")
                      }}, {{ pengumuman.tanggal_kegiatan }}
                    </p>
                  </div>
                  <div class="col-12 mt-20 white-space">
                    <p class="text-m text-bold">{{ pengumuman.pengumuman }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </carousel>
      </div>
      <div v-else>
        <div class="row mt-20">
          <div class="col-12">
            <div class="card-secondary">
              <div class="row">
                <div class="col-12 mt-20 white-space">
                  <p class="text-xl text-bold text-center">
                    TIDAK ADA PENGUMUMAN !
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import carousel from "vue-owl-carousel";
export default {
  name: "Announcement",
  components: {
    carousel,
  },
  data() {
    return {
      dataPengumuman: [],
    };
  },
  methods: {
    drawPengumuman(data) {
      // console.log(data)
      this.dataPengumuman = data;
    },
  },
  mounted() {
    var dateStart = moment().format("YYYY-MM-DD");
    var dateEnd = moment().add(7, "d").format("YYYY-MM-DD");
    axios
      .get(
          `admin/agenda?date_start=${dateStart}&date_end=${dateEnd}`
      )
      .then(
        (response) =>
          // handle success
          this.drawPengumuman(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );
  },
};
</script>

<style scoped>
.card-secondary {
  height: 160px !important;
}

.card-primary {
  height: 260px;
}

.white-space {
  white-space: pre;
}
</style>




// WEBPACK FOOTER //
// src/components/Home/Announcement.vue